import gql from 'graphql-tag';

export const graphFilterGroup = gql `
query ($first: Int, $offset: Int, $filter: GroupFilter, $order: [OrderByInput]) {
  filterGroup(first: $first, filter: $filter, order: $order, offset: $offset) {
    name
    id
  }
}`;

export const graphFilerOptions = gql `
query ($first: Int, $offset: Int, $filter: GroupFilter, $order: [OrderByInput]) {
  filterGroup(first: $first, filter: $filter, order: $order, offset: $offset) {
    name
    id
    fields : searchFields {
      id
      name
      typeId
      title
      searchable
      ... on MultiSelectField {
        options: searchOptions {
          value
          id
        }
      }
      ... on SingleSelectField {
        options: searchOptions {
          value
          id
        }
      }
    }
  }
}`;



// WEBPACK FOOTER //
// ./src/components/graphql.js